module.exports = __webpack_public_path__ + "img/user-02.db1fcba8.jpg";